/* Sleek + UpCart: Serum cards + gifts (from scratch) */
(function () {
  const roots = document.querySelectorAll('.sg-root');
  if (!roots.length) return;

  const fmt = (cents) => {
    try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents); } catch(e){}
    const cur = window.Shopify?.currency?.active || 'USD';
    return (cents/100).toLocaleString(undefined, { style:'currency', currency: cur });
  };
  const fire = (el) => ['change','input'].forEach(t => el.dispatchEvent(new Event(t,{bubbles:true})));


  const updateMainPriceFromVariant = (productInfoEl, v) => {
    try {
      const sectionId = productInfoEl?.dataset.originalSection || productInfoEl?.dataset.section;
      const priceRoot = sectionId ? document.getElementById(`price-${sectionId}`) : null;
      if (!priceRoot || !v) return;
      const saleEl = priceRoot.querySelector('.f-price__sale .f-price-item--sale');
      const regularStrike = priceRoot.querySelector('.f-price__sale .f-price-item--regular s, .f-price__regular .f-price-item--regular s');
      if (saleEl) saleEl.textContent = fmt(v.price);
      if (regularStrike && typeof v.compare_at_price === 'number' && v.compare_at_price > v.price) {
        regularStrike.textContent = fmt(v.compare_at_price);
      }
    } catch(e) { /* noop */ }
  };


  roots.forEach((root) => {
    const variants = JSON.parse(root.dataset.variants || '[]');
    const cfgIndex = parseInt(root.querySelector('.sg-count-index')?.dataset.index || '0', 10);

    // --- Sleek form(s)
    const container = root.closest('[data-product], .product, .product__info-wrapper, section');
    const productInfoEl = root.closest('product-info');
    const productId = productInfoEl?.getAttribute('data-product-id');
    const forms = Array.from(
      document.querySelectorAll(`form[is="product-form"][data-product-id="${productId}"]`)
    );
    if (!forms.length) return;

    // Helpers: read "Serum" count from variant
    const numFrom = (s) => { const m = String(s||'').match(/\d+/); return m ? Math.max(1, Math.min(4, parseInt(m[0],10))) : NaN; };
    const countFromVariant = (v) => {
      if (!v) return 1;
      let n = numFrom(v.options?.[cfgIndex]);
      if (!n) for (const val of (v.options||[])) { n = numFrom(val); if (n) break; }
      return n || 1;
    };

    // Build map 1..4 -> first available variant
    const byCount = {1:null,2:null,3:null,4:null};
    variants.forEach(v => { 
      const n = countFromVariant(v); 
      if (!byCount[n] && v.available) byCount[n] = v; 
    });

    // Fill "$/Each" from REAL variant prices
    [1,2,3,4].forEach((n) => {
      const slot = root.querySelector(`[data-sub-for="${n}"]`);
      const v = byCount[n];
      if (!slot) return;
      if (v && typeof v.price === 'number') {
        const each = Math.round(v.price / n);
        slot.textContent = `${fmt(each)}/each`;
      } else {
        slot.textContent = '';
      }
    });

    // Cards + gifts
    const cards = Array.from(root.querySelectorAll('.sg-card'));
    cards.forEach(btn => { 
      const n = parseInt(btn.dataset.count,10); 
      if (!byCount[n]) { 
        btn.disabled = true; 
        btn.classList.add('is-disabled');
        btn.style.display = 'none'; // Hide unavailable variants
      } 
    });

    const gifts = Array.from(root.querySelectorAll('.sg-gift'));
    const allowedEl = root.querySelector('[data-allowed]');
    const selectedEl= root.querySelector('[data-selected]');

    let allowed = 0;
    let selectedGifts = new Set();
    let activeVariant = null;
    let activeCount   = 1;

    const updateGiftUI = () => {
      const cap = Number.isFinite(allowed) ? allowed : 0;
      gifts.forEach((btn, idx) => {
        const lock = idx >= cap || btn.disabled;
        btn.classList.toggle('is-locked', lock);
        const on = selectedGifts.has(btn.dataset.variantId);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-selected', on);
      });
      if (allowedEl)  allowedEl.textContent  = cap;
      if (selectedEl) selectedEl.textContent = selectedGifts.size;
    };
    
    const autoPick = () => {
      if (selectedGifts.size >= allowed) return;
      for (const b of gifts) {
        if (b.disabled) continue;
        if (selectedGifts.size >= allowed) break;
        selectedGifts.add(b.dataset.variantId);
      }
    };
    
    // Updated gift unlocking logic: 1→0, 2→2, 3→3, 4→4
    const computeAllowed = (c) => {
      const n = Number(c);
      if (!Number.isFinite(n) || n <= 1) return 0;
      return Math.min(n, gifts.filter(b=>!b.disabled).length);
    };

    // Select a real variant in Sleek form (so price/images change)
    const selectVariant = (v) => {
      if (!v) return;
      
      console.log('Selecting variant:', v);
      
      // Update the variant UI by interacting with inputs inside <variant-selects>
      // We iterate fieldsets in order and click the matching value.
      const variantWidget = productInfoEl?.querySelector('variant-selects');
      const fields = variantWidget
        ? Array.from(variantWidget.querySelectorAll('.product-form__input'))
        : [];
      (v.options || []).forEach((val, idx) => {
        const field = fields[idx] || variantWidget;
        if (!field) return;
        // Prefer radios (button/color pickers)
        let r = field && field.querySelector(`input[type="radio"][value="${CSS.escape(val)}"]`);
        if (r) {
          if (!r.checked) r.click();
          return;
        }
        // Fallback to select dropdown
        const sel = field && field.querySelector('select[name^="options["], select');
        if (sel && sel.value !== val) {
          sel.value = val;
          fire(sel);
        }
      });



    // Ensure theme's product-info refresh runs (updates price block)
      try {
        const selectedEls = variantWidget
          ? Array.from(variantWidget.querySelectorAll('select option[selected], fieldset input:checked'))
          : [];
        const selectedOptionValues = selectedEls
          .map((el) => el?.dataset?.optionValueId)
          .filter(Boolean);
        const lastTarget = (() => {
          const last = selectedEls[selectedEls.length - 1];
          if (!last) return variantWidget;
          const select = last.closest('select');
          if (select && select.selectedOptions && select.selectedOptions[0]) return select.selectedOptions[0];
          return last;
        })();
        if (window.FoxTheme?.pubsub?.publish && selectedOptionValues.length) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              // Only event.target is used downstream; pass a lightweight object
              event: { target: lastTarget },
              target: lastTarget,
              selectedOptionValues,
            },
          });

          // Directly call product-info's renderer as a reliable path
          try {
            const pi = productInfoEl;
            if (pi && typeof pi.buildRequestUrlWithParams === 'function' && typeof pi.renderProductInfo === 'function') {
              const req = pi.buildRequestUrlWithParams(pi.dataset.url || location.pathname, selectedOptionValues, false);
              const viewMode = pi.dataset.viewMode || 'main-product';
              const cb = pi.handleUpdateProductInfo(pi.dataset.url || location.pathname, viewMode);
              pi.renderProductInfo({ requestUrl: req, targetId: (variantWidget && variantWidget.id) || '', callback: cb });
            }
          } catch (e) { /* noop */ }

          // Fallback: directly fetch updated HTML for this section and swap the price
          const sectionId = productInfoEl?.dataset.originalSection || productInfoEl?.dataset.section;
          const baseUrl = productInfoEl?.dataset.url;
          if (sectionId && baseUrl) {
            const url = `${baseUrl}?section_id=${sectionId}&option_values=${selectedOptionValues.join(',')}`;
            fetch(url)
              .then((r) => r.text())
              .then((txt) => {
                const parsed = new DOMParser().parseFromString(txt, 'text/html');
                const src = parsed.getElementById(`price-${sectionId}`);
                const dst = document.getElementById(`price-${sectionId}`);
                if (src && dst) dst.innerHTML = src.innerHTML;
              })
              .catch(() => {});
          }
        }
      } catch (e) { /* noop */ }


      
      // Also update any other variant ID inputs for this product (main + sticky ATC)
      const allIdInputs = document.querySelectorAll(
        `form[is="product-form"][data-product-id="${productId}"] input[name="id"]`
      );
      allIdInputs.forEach((input) => {
        if (String(input.value) !== String(v.id)) {
          input.value = String(v.id);
          fire(input);
        }
      });

      // Update quantity input if it has a data-quantity-variant-id
      const qtyInputs = document.querySelectorAll(
        `form[is="product-form"][data-product-id="${productId}"] input[name="quantity"]`
      );
      qtyInputs.forEach(input => {
        if (input.dataset.quantityVariantId) {
          input.dataset.quantityVariantId = String(v.id);
        }
      });

      activeVariant = v;
      activeCount   = countFromVariant(v);
      if (!Number.isFinite(activeCount)) activeCount = 1;

      // Update URL with ?variant=...
      try {
        const productInfo = container?.closest('product-info') || document.querySelector('product-info');
        const baseUrl = productInfo?.dataset?.url || location.pathname;
        if (v?.id) history.replaceState({}, '', `${baseUrl}?variant=${v.id}`);
      } catch(e) { /* noop */ }

      // Fire a variant changed event for any listeners
      try {
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } }));
      } catch(e) { /* noop */ }

      // As a final safeguard, overwrite the visible price immediately
      updateMainPriceFromVariant(productInfoEl, v);

      // Update card UI
      cards.forEach(b => {
        const on = parseInt(b.dataset.count,10) === activeCount;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });

      allowed = computeAllowed(activeCount);
      
      // Auto-select gifts based on variant count
      selectedGifts.clear();
      console.log('Clearing selected gifts, activeCount:', activeCount);
      
      if (activeCount >= 4) {
        // 4 bottles: all gifts unlocked and auto-selected
        const allGifts = gifts.filter(b=>!b.disabled);
        selectedGifts = new Set(allGifts.map(b=>b.dataset.variantId));
        console.log('4+ bottles: selecting all gifts:', Array.from(selectedGifts));
      } else if (activeCount >= 3) {
        // 3 bottles: 3 gifts unlocked and auto-selected
        const availableGifts = gifts.filter(b=>!b.disabled).slice(0, 3);
        selectedGifts = new Set(availableGifts.map(b=>b.dataset.variantId));
        console.log('3 bottles: selecting 3 gifts:', Array.from(selectedGifts));
        console.log('Available gifts for 3 bottles:', availableGifts.map(g => ({
          id: g.dataset.variantId,
          title: g.querySelector('.sg-gift__title')?.textContent
        })));
      } else if (activeCount >= 2) {
        // 2 bottles: 2 gifts unlocked and auto-selected
        const availableGifts = gifts.filter(b=>!b.disabled).slice(0, 2);
        selectedGifts = new Set(availableGifts.map(b=>b.dataset.variantId));
        console.log('2 bottles: selecting 2 gifts:', Array.from(selectedGifts));
      }
      // 1 bottle: no gifts (already handled by computeAllowed)
      
      updateGiftUI();
      console.log('Final selected gifts after variant selection:', Array.from(selectedGifts));
      console.log('Selected gifts Set size:', selectedGifts.size);
    };

    // Card clicks
    cards.forEach(btn => btn.addEventListener('click', () => {
      if (btn.disabled) return;
      const n = parseInt(btn.dataset.count,10);
      console.log('Card clicked:', n, 'bottles');
      selectVariant(byCount[n]);
      
      // Force a small delay to ensure form updates are processed
      setTimeout(() => {
        // Double-check that the product forms have the correct variant
        const anyIdInput = document.querySelector(
          `form[is="product-form"][data-product-id="${productId}"] input[name="id"]`
        );
        if (anyIdInput && anyIdInput.value !== String(byCount[n].id)) {
          console.log('Re-applying variant selection');
          selectVariant(byCount[n]);
        }
      }, 100);
    }));

    // Gift clicks (toggle within cap)
    gifts.forEach(btn => btn.addEventListener('click', () => {
      if (btn.classList.contains('is-locked') || btn.disabled) return;
      const id = btn.dataset.variantId;
      if (selectedGifts.has(id)) selectedGifts.delete(id);
      else {
        if (selectedGifts.size >= allowed) {
          const last = Array.from(selectedGifts)[selectedGifts.size - 1];
          if (last) selectedGifts.delete(last);
        }
        selectedGifts.add(id);
      }
      updateGiftUI();
    }));

    // Sync when native picker changes (any product form for this product)
    forms.forEach((f) => {
      f.addEventListener('change', (e) => {
        const tgt = e.target;
        const name = (tgt.name || '').toLowerCase();
        if (name === 'id' || name.startsWith('options[') || tgt.closest('variant-selects')) {
          const val = f.querySelector('input[name="id"]')?.value;
          const v = variants.find((x) => String(x.id) === String(val));
          if (v) selectVariant(v);
        }
      });
    });

    // Also react to global variant:changed fired by theme
    document.addEventListener('variant:changed', (evt) => {
      const v = evt.detail?.variant;
      if (v && variants.some((x) => Number(x.id) === Number(v.id))) {
        const full = variants.find((x) => Number(x.id) === Number(v.id));
        if (full) selectVariant(full);
      }
    });

    // Initialize to URL/current (only if URL has ?variant), else prefer preselect setting, else best-deal, else highest available
    (function init() {
      const anyIdInput = document.querySelector(
        `form[is="product-form"][data-product-id="${productId}"] input[name="id"]`
      );
      const current = variants.find(v => String(v.id) === String(anyIdInput?.value));
      const hasVariantInUrl = (() => {
        try { return new URL(location.href).searchParams.has('variant'); } catch(e) { return false; }
      })();
      if (hasVariantInUrl && current) { selectVariant(current); return; }

      // Explicit preselect from block setting
      const preselectStr = root.getAttribute('data-preselect-serum');
      const preselect = Number.isFinite(parseInt(preselectStr, 10)) ? parseInt(preselectStr, 10) : 0;
      if (preselect && byCount[preselect]) { selectVariant(byCount[preselect]); return; }

      // If there's no current/URL variant, try the block's best deal
      const bestDealStr = root.getAttribute('data-best-deal-for');
      const bestDeal = parseInt(bestDealStr || '0', 10);
      if (bestDeal && byCount[bestDeal]) { selectVariant(byCount[bestDeal]); return; }

      // Fallback to highest available 4→3→2→1
      for (const n of [4,3,2,1]) { if (byCount[n]) { selectVariant(byCount[n]); break; } }
      
      // Debug: Log all gifts on initialization
      console.log('=== GIFT DEBUG ===');
      console.log('All gifts:', gifts.map(g => ({
        id: g.dataset.variantId,
        title: g.querySelector('.sg-gift__title')?.textContent,
        disabled: g.disabled,
        available: !g.disabled,
        element: g
      })));
      console.log('Gift count:', gifts.length);
      console.log('Available gifts:', gifts.filter(g => !g.disabled).length);
      
      // Check if gifts are actually rendered
      const giftElements = document.querySelectorAll('.sg-gift');
      console.log('Gift elements found:', giftElements.length);
      console.log('Gift elements:', Array.from(giftElements).map(g => ({
        id: g.dataset.variantId,
        title: g.querySelector('.sg-gift__title')?.textContent,
        disabled: g.disabled
      })));
      
      // Check block configuration
      const blockElement = document.querySelector('.sg-root');
      if (blockElement) {
        console.log('Block found:', blockElement.id);
        console.log('Block data variants:', blockElement.dataset.variants);
        
        // Read debug info
        const debugInfo = blockElement.querySelector('.sg-debug-info');
        if (debugInfo) {
          try {
            const debugData = JSON.parse(debugInfo.textContent);
            console.log('=== BLOCK SETTINGS DEBUG ===');
            console.log('Gift 1:', debugData.gift_1);
            console.log('Gift 2:', debugData.gift_2);
            console.log('Gift 3:', debugData.gift_3);
            console.log('Gift 4:', debugData.gift_4);
            console.log('Serum option name:', debugData.serum_option_name);
            
            // Check which gifts are configured
            const configuredGifts = [];
            for (let i = 1; i <= 4; i++) {
              if (debugData[`gift_${i}`]) {
                configuredGifts.push(`Gift ${i}: ${debugData[`gift_${i}`].title || 'Unknown'}`);
              } else {
                configuredGifts.push(`Gift ${i}: NOT CONFIGURED`);
              }
            }
            console.log('Configured gifts:', configuredGifts);
            
            // Test gift functionality
            console.log('=== GIFT FUNCTIONALITY TEST ===');
            if (gifts.length > 0) {
              console.log('✅ Gift elements found');
              const availableGifts = gifts.filter(g => !g.disabled);
              console.log(`✅ Available gifts: ${availableGifts.length}`);
              
              if (availableGifts.length > 0) {
                console.log('✅ Gift functionality should work');
                console.log('Available gift IDs:', availableGifts.map(g => g.dataset.variantId));
              } else {
                console.error('❌ No available gifts found');
              }
            } else {
              console.error('❌ No gift elements found');
            }
          } catch (e) {
            console.error('Error parsing debug info:', e);
          }
        }
      } else {
        console.error('No .sg-root block found!');
      }
    })();

    // === Sleek + Cart: authoritative add (main + gifts) ===
    const onSubmitAddBundle = async (e) => {
      e.preventDefault(); // we will add via fetch and then open the cart drawer
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      console.log('Form submitted, active variant:', activeVariant);

      // 1) Resolve the REAL variant the shopper chose
      const formEl = e.target;
      const idInput = formEl.querySelector('input[name="id"]');
      const qtyInput = formEl.querySelector('[name="quantity"]');
      let mainVar = activeVariant || variants.find(v => String(v.id) === String(idInput?.value));
      if (!mainVar) {
        console.error('No variant found, falling back to form submit');
        return form.submit(); // safety fallback
      }

      // Double-check that we have the correct variant
      const currentFormVariantId = idInput?.value;
      if (currentFormVariantId && String(mainVar.id) !== String(currentFormVariantId)) {
        console.log('Form variant ID mismatch, updating form');
        mainVar = variants.find(v => String(v.id) === String(currentFormVariantId));
        if (!mainVar) {
          console.error('Could not find variant for form ID:', currentFormVariantId);
          return form.submit();
        }
      }

      console.log('Using variant:', mainVar);

      // 2) Get the shopper's bundle quantity (qty field next to the ATC button)
      const bundleQty = parseInt(qtyInput?.value || '1', 10) || 1;

      // 3) Compute how many gifts to allow from the chosen variant (1→0, else count)
      const countFromString = (s) => { const m = String(s||'').match(/\d+/); return m ? Math.max(1, Math.min(4, parseInt(m[0],10))) : 1; };
      const countFromVariant  = (v) => {
        const cfgIndex = parseInt(root.querySelector('.sg-count-index')?.dataset.index || '0', 10);
        let n = countFromString(v.options?.[cfgIndex]);
        if (!n) for (const val of (v.options||[])) { const m = countFromString(val); if (m) { n = m; break; } }
        return n || 1;
      };
      const count = countFromVariant(mainVar);

      console.log('Variant count:', count);

      const enabledGifts = gifts.filter(b => !b.disabled);
      let allowedGifts = count <= 1 ? 0 : Math.min(count, enabledGifts.length);

      console.log('Allowed gifts:', allowedGifts);
      console.log('Enabled gifts:', enabledGifts.map(g => ({ id: g.dataset.variantId, title: g.querySelector('.sg-gift__title')?.textContent })));

      // Auto-pick if customer hasn't picked enough
      console.log('Before auto-pick - selectedGifts size:', selectedGifts.size, 'allowedGifts:', allowedGifts);
      if (selectedGifts.size < allowedGifts) {
        console.log('Auto-picking gifts...');
        for (const b of enabledGifts) {
          if (selectedGifts.size >= allowedGifts) break;
          console.log('Auto-adding gift:', b.dataset.variantId, b.querySelector('.sg-gift__title')?.textContent);
          selectedGifts.add(b.dataset.variantId);
        }
        console.log('After auto-pick - selectedGifts size:', selectedGifts.size);
      } else {
        console.log('No auto-pick needed, already have enough gifts');
      }

      console.log('Selected gifts before cart:', Array.from(selectedGifts));
      console.log('Selected gifts Set size before cart:', selectedGifts.size);

      // 4) Build the multi-item payload
      const bundleId = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
      const items = [
        { id: Number(mainVar.id), quantity: bundleQty, properties: { _bundle: bundleId } }
      ];
      
      // Fix: Use all selected gifts, not just slice(0, allowedGifts)
      const selectedGiftIds = Array.from(selectedGifts);
      console.log('Gift IDs to add:', selectedGiftIds);
      console.log('Selected gifts count:', selectedGiftIds.length);
      console.log('Allowed gifts count:', allowedGifts);
      console.log('SelectedGifts Set contents:', Array.from(selectedGifts));
      
      // Debug: Check each gift ID
      selectedGiftIds.forEach((vid, index) => {
        console.log(`Gift ${index + 1} ID:`, vid, 'Type:', typeof vid, 'Valid:', vid && vid !== 'undefined' && vid !== 'null');
      });
      
      selectedGiftIds.forEach((vid, index) => {
        if (vid && vid !== 'undefined' && vid !== 'null') {
          console.log(`Adding gift ${index + 1}:`, vid);
          items.push({
            id: Number(vid),
            quantity: bundleQty,                          // one set of gifts per bundle qty
            properties: { Free: 'Free!', _free_gift: 'true', _bundle: bundleId }
          });
        } else {
          console.warn('Invalid gift variant ID:', vid);
        }
      });

      console.log('Final items array:', items);
      console.log('Total items to add:', items.length);
      console.log('Items breakdown:', items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        isGift: item.properties._free_gift === 'true'
      })));

      // 5) Add to cart via Shopify API
      try {
        console.log('=== CART API TEST ===');
        console.log('Sending request to /cart/add.js');
        console.log('Request payload:', JSON.stringify({ items }, null, 2));
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Cart add failed:', response.status, errorText);
          throw new Error('Add to cart failed: ' + response.status);
        }
        
        const result = await response.json();
        console.log('✅ Cart add successful');
        console.log('Added to cart:', result);
        
        // Verify items were added
        let addedCount = 0;
        let addedVariantIds = [];
        if (result && Array.isArray(result.items)) {
          addedCount = result.items.length;
          addedVariantIds = result.items.map(it => Number(it.variant_id || it.id)).filter(Boolean);
          console.log('Items in cart after add:', addedCount);
          result.items.forEach((item, index) => {
            console.log(`Item ${index + 1}:`, {
              id: item.variant_id || item.id,
              title: item.product_title,
              quantity: item.quantity,
              properties: item.properties
            });
          });
        } else if (result && (result.variant_id || result.id)) {
          // Some apps (e.g., UpCart) return only the first added item
          addedCount = 1;
          addedVariantIds = [Number(result.variant_id || result.id)];
          console.warn('Response contained a single item object instead of items[].');
        }

        // If bulk add did not include all gifts, add missing gifts sequentially
        const expectedVariantIds = [Number(mainVar.id), ...selectedGiftIds.map(Number)];
        const missingGiftIds = expectedVariantIds.filter((vid, idx) => idx > 0 && !addedVariantIds.includes(vid));
        if (missingGiftIds.length) {
          console.warn('Detected missing gifts after bulk add. Adding sequentially now...', missingGiftIds);
          for (const vid of missingGiftIds) {
            console.log('Adding missing gift', vid);
            const r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: Number(vid),
                quantity: bundleQty,
                properties: { Free: 'Free!', _free_gift: 'true', _bundle: bundleId }
              })
            });
            if (!r.ok) {
              const tt = await r.text();
              console.error('Failed to add missing gift', vid, r.status, tt);
            } else {
              console.log('Added missing gift', vid);
            }
          }
        }
        
        // 6) Trigger cart refresh event for the cart drawer
        console.log('Triggering cart:refresh event');
        document.dispatchEvent(new CustomEvent('cart:refresh', { 
          detail: { open: true } 
        }));
        
      } catch (err) {
        console.warn('Bulk add may be unsupported. Falling back to sequential adds...', err);
        
        // Sequential fallback: add main first, then gifts one by one
        try {
          // Add main variant
          console.log('Fallback: adding main variant only');
          const addMainRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: Number(mainVar.id),
              quantity: bundleQty,
              properties: { _bundle: bundleId }
            })
          });
          if (!addMainRes.ok) {
            const t = await addMainRes.text();
            throw new Error('Fallback main add failed: ' + addMainRes.status + ' ' + t);
          }
          console.log('Fallback: main variant added');
          
          // Add gifts sequentially
          for (const vid of selectedGiftIds) {
            console.log('Fallback: adding gift', vid);
            const r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: Number(vid),
                quantity: bundleQty,
                properties: { Free: 'Free!', _free_gift: 'true', _bundle: bundleId }
              })
            });
            if (!r.ok) {
              const tt = await r.text();
              console.error('Fallback: gift add failed for', vid, r.status, tt);
            } else {
              console.log('Fallback: gift added', vid);
            }
          }
          
          // Refresh cart drawer
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } catch (fallbackErr) {
          console.error('❌ Sequential fallback also failed. Submitting native form.', fallbackErr);
          return form.submit();
        }
      }
    };

    // Bind in capture phase for all relevant forms (main + sticky ATC)
    forms.forEach((f) => f.addEventListener('submit', onSubmitAddBundle, { capture: true }));

  });
})();
